import React, { useState, useCallback } from "react"
import { Drawer } from "antd"
import StageForm from "~/components/StageForm"

const useStage = ({ stage, loading = false, width = "60%", onClose, onSubmit, onRemove } = {}) => {
  const [visible, setVisible] = useState(false)
  const show = () => setVisible(true)
  const hide = () => setVisible(false)
  const onCancel = () => {
    onClose && onClose()
    hide()
  }

  const StageDrawer = useCallback(() => {
    return (
      <Drawer
        width={width}
        closeIcon={null}
        keyboard={false}
        title={"Giai đoạn"}
        open={visible}
        onClose={onCancel}
      >
        <StageForm
          id={stage?.id}
          initialValues={{
            ...stage,
          }}
          onSubmit={onSubmit}
          onRemove={onRemove}
          onCancel={onCancel}
          loading={loading}
        />
      </Drawer>
    )
    // eslint-disable-next-line
  }, [visible])

  return {
    visible,
    show,
    hide,
    StageDrawer,
  }
}

export default useStage
